import { AuthUser } from '@/core/classes/Auth'
import { Expertise } from '@/core/models/expertise.model'

export function redirectTo(user: AuthUser, expertise: Expertise): { redirect: boolean; url: string } {
  const hasIntro = window.location.search.includes('intro=true')
  if (window.location.pathname.includes(`/expertises/${expertise._id}/update`) && user._id === expertise.createdBy._id) {
    return {
      redirect: false,
      url: '',
    }
  }

  if (expertise.status === 'draft' && user._id === expertise.createdBy._id) {
    // if url contains ?intro=true, pass query param to redirect url

    return {
      redirect: true,
      url: `/expertises/${expertise._id}/update?intro=${hasIntro}`,
    }
  }

  if (expertise.status === 'closed' && window.location.pathname.includes(`/expertises/${expertise._id}/update`)) {
    return {
      redirect: true,
      url: `/expertises/${expertise._id}`,
    }
  }

  return {
    redirect: false,
    url: `/expertises/${expertise._id}`,
  }
}
